import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "VideoPlayer",
    component: () => (__SERVER__ ? require("./video-player-view") : import("./video-player-view"))
});

export default definition;
